import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IState } from 'redux/reducers';
import { Scope } from 'redux/reducers/authReducer';
import { usePermission } from 'hooks/usePermission';
import { NotAuthrorized } from './atom/not-authorized';

declare global {
  interface Window {
    olark: any;
  }
}

interface PrivateRouterProps extends RouteProps {
  scope?: Scope;
}

const PrivateRoute: React.FC<PrivateRouterProps> = (props) => {
  const auth = useSelector((state: IState) => state.auth);
  const hasPermission = usePermission(props.scope!);
  if (!auth.isAuthenticated) {
    return <Redirect to="/sign-in" />;
  }

  if (props.scope) {
    if (!hasPermission) {
      return <NotAuthrorized />;
    }
  }

  window.olark('api.visitor.updateEmailAddress', {
    emailAddress: auth.currentUser.email,
  });

  window.olark('api.visitor.updateFullName', {
    fullName: auth.currentUser.fullName,
  });

  return <Route {...props} />;
};

export default PrivateRoute;
